import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';

import { faEnvelope, faEye, faEyeSlash, faLock, faUser, faKey, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { MessageService } from 'primeng/api';
import { OTPLogin } from '../Models/CmsLoginMainContentProperties';
import { LoginUserProperties } from '../Models/UsersProperties';
import { CMSService } from '../Services/cms.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent {
  emailIcon = faEnvelope;
  companyName = environment.companyName;
  emailSubmitted: boolean = false;
  validEmailForm!: boolean;
  forgotpasswordsection: boolean = true;
  otpsection: boolean = false;
  newpasswordsection: boolean = false;
  completedsuccessfully: boolean = false;
  loadVar: boolean = false;
  loginCred = new LoginUserProperties();
  passwordIcon = faLock;
  eyeIcon = faEye;
  faUser = faUser;
  faCode = faKey;
  faBuilding = faBuilding;
  otp: string = "";
  closeEyeIcon = faEyeSlash;
  visiblePassword: boolean = true;
  changetypePassword: boolean = true;
  visibleConfirmPassword: boolean = true;
  changetypeConfirmPassword: boolean = true;
  validPasswordForm!:boolean;
  dataotpform!: boolean;
  passwordSubmitted:boolean=false;
  constructor(private cmsService: CMSService, private messageService: MessageService, private router: Router) {
  }
  public ValidateEmail = (email: string): boolean => {
    const regularExpression =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  public verifyOTP = (dataform: any) => {
    this.dataotpform = true;
    if (dataform.Invalid) {
      return;
    }
    try {
      this.loginCred.otp = this.otp;
      this.cmsService.ForgotemailOTPVerify(this.loginCred).subscribe((data) => {
        if (data == true) {
          localStorage.setItem("UserId", this.loginCred.userId.toString());
          localStorage.setItem("AgencyId", this.loginCred.agencyId);
          localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
          localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);
          this.otpsection = false;
          this.newpasswordsection = true;
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid OTP!', life: 5000 });

        }
      });
    } catch (e) { }
  }
  SendMailSubmit(form: NgForm): boolean {
    this.emailSubmitted = true;
    if (form.invalid) {
      this.validEmailForm = false;
    }
    else 
       {
        this.validEmailForm = true;
        this.loginCred.loginName = form.value.email;
        this.loginCred.agencyId = form.value.agency;
        this.loadVar = true;
        this.cmsService.UserFogotEmail(this.loginCred).subscribe({
          next: (data) => {
            if (data.isAuthorized) {
              this.loginCred.email = data.email;
              this.loginCred.userId = data.userId;
              this.loginCred.parentAgency = data.parentAgency;
              this.loginCred.immediateParent = data.immediateParent;
              this.otpsection = true;
              this.newpasswordsection = false;
              this.forgotpasswordsection = false;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Try Again!', life: 5000 });
            }
            
            this.loadVar = false;
          }, error: (error: any) => {
            console.log(error)
            this.loadVar = false;
            
            this.messageService.add({ severity: 'error', summary: 'Error', detail: `Something Went Wrong!`, life: 5000 });
          }
        });

      }
    
    return this.validEmailForm;
  }
  ShowPassword() {
    this.visiblePassword = !this.visiblePassword;
    this.changetypePassword = !this.changetypePassword;
  }
  ShowConfirmPassword() {
    this.visibleConfirmPassword = !this.visibleConfirmPassword;
    this.changetypeConfirmPassword = !this.changetypeConfirmPassword;
  }
  public PasswordLenghtCheck = (): boolean => {
    if (this.loginCred.password) {
      if (this.loginCred.password.toString()!.length < 8) {
        return true;
      }
      else {
        return false;
      }

    }
    else {
      return true;
    }
  }

  NewPasswordSubmit(form: NgForm): boolean {
    this.passwordSubmitted = true;
    if (form.invalid) {
      this.validPasswordForm = false;
    }
    else {
      if (this.PasswordLenghtCheck() || form.value.confirmpassword != form.value.password) {
        this.validPasswordForm = false;
      }
      else {
        this.validPasswordForm = true;
        this.loadVar = true;
        this.cmsService.ForgotResetPassword(this.loginCred).subscribe({
          next: (data) => {
            if (data == true) {
              this.messageService.add({ severity: 'success', summary: 'Successfully Changed!', detail: 'Login Now!', life: 5000 });
              this.newpasswordsection = false;
              this.completedsuccessfully = true;
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: `Something Went Wrong!`, life: 5000 });

            }
            this.loadVar = false;
          }, error: (error: any) => {
            console.log(error)
            this.loadVar = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: `Something Went Wrong!`, life: 5000 });
          }
        });

      }
    }
    return this.validPasswordForm;
  }
  
}
